"use client";

import type { UseRequestInfiniteQueryProps } from "../../../request/hooks/useRequestInfiniteQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyParishSearch } from "./keyParishSearch";
import { requestParishSearchRequestProps } from "./requestParishSearch";

export type UseRequestParishSearchProps =
  Partial<UseRequestInfiniteQueryProps> & {
    filters?: {
      status?: Array<"active" | "launched">;
    };
    search: string;
    searchService?: boolean;
  };

export const useRequestParishSearch = ({
  filters = { status: ["active", "launched"] },
  search,
  searchService = false,
}: UseRequestParishSearchProps) => ({
  query: useRequestQuery({
    enabledWithoutSessionToken: true,
    queryFnRequestProps: () => ({
      ...requestParishSearchRequestProps(search, filters, { searchService }),
    }),
    queryKey: keyParishSearch({ filters, search, searchService }),
  }),
});
